export const TEMPLATE_SETTINGS = [
  {
    name: 'JavaScript with Express',
    description: 'Minimal and flexible Node.js framework for REST APIs.',
    useCase: 'Great for simple APIs or microservices.',
    language: 'javascript',
    icon: 'mdi-language-javascript',
    color: 'green',
    repo: 'https://github.com/Qlerify/qlerify-starter-javascript-express/tree/main'
  },
  {
    name: 'TypeScript with NestJS',
    description: 'Modular, scalable TypeScript framework supporting DDD and CQRS.',
    useCase: 'Great for large apps needing structure.',
    language: 'typescript',
    icon: 'mdi-language-typescript',
    color: 'indigo',
    repo: 'https://github.com/Qlerify/qlerify-starter-typescript-nestjs/tree/main',
    disabled: true
  },
  {
    name: 'Python with FastAPI',
    description: 'Modern Python web framework with async and type hints.',
    useCase: 'Ideal for fast, async-ready services.',
    language: 'python',
    icon: 'mdi-language-python',
    color: 'blue-darken-2',
    repo: 'https://github.com/Qlerify/qlerify-starter-python-fastapi/tree/main',
    disabled: true
  },
  {
    name: 'Java with Spring Boot',
    description: 'Enterprise-grade framework with powerful DDD support.',
    useCase: 'Perfect for microservices and monoliths alike.',
    language: 'java',
    icon: 'mdi-language-java',
    color: 'deep-orange-darken-2',
    repo: 'https://github.com/Qlerify/qlerify-starter-java-springboot/tree/main',
    disabled: true
  },
  {
    name: 'C# with ASP.NET Core',
    description: 'Modern .NET framework with excellent support for DDD and CQRS.',
    useCase: 'Reliable for scalable cross-platform apps.',
    language: 'csharp',
    icon: 'mdi-microsoft-windows',
    color: 'purple',
    repo: 'https://github.com/Qlerify/qlerify-starter-csharp-aspnetcore/tree/main',
    disabled: true
  },
  {
    name: 'Go with Fiber',
    description: 'Express-inspired Go web framework focused on speed.',
    useCase: 'Ideal for lightweight APIs and high-performance apps.',
    language: 'golang',
    icon: 'mdi-language-go',
    color: 'teal',
    repo: 'https://github.com/Qlerify/qlerify-starter-go-fiber/tree/main',
    disabled: true
  }
]

export const LEGACY_PROJECT_TEMPLATE = {
  name: 'Legacy Project',
  description: 'Project from an existing repository.',
  useCase: 'Used when a workflow is generated from a pre-existing codebase.',
  language: 'custom',
  icon: 'mdi-file-code-outline',
  color: 'blue-grey',
  repo: '',
  isLegacy: true
}

export const DOMAIN_MODEL_STRUCTURE = {
  'domain-model': {
    readmodel: {},
    command: {},
    entity: {},
    gwt: {}
  }
}

// project-root/
// ├── src/
// │   ├── domain/
// │   │   ├── entities/
// │   │   │   └── Customer.js
// │   │   └── commands/
// │   │       └── CreateCustomer.js
// │   ├── read-models/
// │   │   └── CustomerSummary.js
// │   ├── automations/
// │   │   └── NotifyOnCustomerCreated.js
// │   ├── api/
// │   │   └── customerRoutes.js
// │   ├── config/
// │   ├── services/              # shared logic, e.g., DB or email service
// │   └── index.js
// ├── test/
// ├── swagger/
// ├── package.json
export const NODEJS_BOOTSTRAP_STRUCTURE = {
  root: {
    src: {
      bootstrap: {
        'app.js': {},
        'express.js': {},
        'loader.js': {}
      },
      config: {
        'index.js': {}
      },
      domain: {
        command: {},
        entity: {},
        readmodel: {}
      },
      infrastructure: {
        db: {
          'index.js': {},
          'memory.js': {},
          'mongo.js': {},
          'sqlite.js': {}
        }
      },
      interfaces: {
        http: {}
      },
      routes: {
        'index.js': {}
      }
    },
    'package.json': {},
    'server.js': {}
  }
}

export const NODEJS_ENTITY_FOLDER_PATH = [
  'root/src/domain/',
  'root/src/interfaces/http/'
]
export const NODEJS_COMMAND_FOLDER_PATH = [
  'root/src/domain/',
  'root/src/interfaces/http/'
]
export const NODEJS_READ_MODEL_FOLDER_PATH = [
  'root/src/domain/',
  'root/src/interfaces/http/'
]
export const NODEJS_AUTOMATION_FOLDER_PATH = ['root/src/automations/']

// ProjectRoot/
// ├── ProjectName.Domain/
// │   ├── Entities/
// │   │   └── Customer.cs
// │   ├── ValueObjects/
// │   ├── Interfaces/
// │   │   └── ICustomerRepository.cs
// │   ├── Events/
// │   │   └── CustomerCreatedEvent.cs
// │   └── SharedKernel/
// │       └── BaseEntity.cs
// │
// ├── ProjectName.Application/
// │   ├── Commands/
// │   │   └── Customer/
// │   │       ├── CreateCustomerCommand.cs
// │   │       └── Handlers/
// │   │           └── CreateCustomerHandler.cs
// │   ├── Queries/
// │   │   └── Customer/
// │   │       ├── GetCustomerSummaryQuery.cs
// │   │       ├── CustomerSummaryDto.cs
// │   │       └── Handlers/
// │   │           └── GetCustomerSummaryHandler.cs
// │   ├── EventHandlers/
// │   │   └── CustomerCreatedHandler.cs
// │   ├── Interfaces/
// │   │   └── IEmailSender.cs
// │   └── Services/
// │       └── EmailService.cs
// │
// ├── ProjectName.Infrastructure/
// │   ├── Persistence/
// │   │   ├── AppDbContext.cs
// │   │   ├── Configurations/
// │   │   └── Repositories/
// │   │       └── CustomerRepository.cs
// │   ├── BackgroundJobs/
// │   │   └── BirthdayEmailJob.cs
// │   ├── EventBus/
// │   │   ├── Publisher.cs
// │   │   └── Subscriber.cs
// │   └── Services/
// │       └── EmailSender.cs
// │
// ├── ProjectName.API/
// │   ├── Controllers/
// │   │   └── CustomerController.cs
// │   ├── DTOs/
// │   ├── Filters/
// │   ├── Program.cs
// │   └── appsettings.json
// │
// ├── ProjectName.Tests/
// │   ├── Unit/
// │   │   └── Application/
// │   └── Integration/
// │       └── API/
// │
// └── ProjectName.sln
export const ASPNET_FOLDER_STRUCTURE = {
  root: {
    Controllers: {},
    Models: {},
    Services: {},
    Repositories: {},
    DTOs: {},
    Middleware: {},
    Configuration: {},
    'appsettings.json': {},
    'Program.cs': {},
    'Startup.cs': {},
    'README.md': {},
    prompts: {
      'promptReadModel.txt': {},
      'promptCommand.txt': {},
      'promptEntity.txt': {},
      'promptAutomation.txt': {}
    }
  }
}

// project-root/
// ├── src/
// │   └── main/
// │       ├── java/
// │       │   └── com/example/project/
// │       │       ├── domain/
// │       │       │   ├── customer/
// │       │       │   │   ├── model/                  # Entity classes, value objects
// │       │       │   │   └── events/                 # Domain events (e.g., CustomerCreatedEvent)
// │       │       │   └── order/
// │       │       │       ├── model/
// │       │       │       └── events/
// │       │       ├── application/
// │       │       │   ├── command/                    # Command DTOs and use cases
// │       │       │   │   └── customer/
// │       │       │   │       ├── CreateCustomerCommand.java
// │       │       │   │       └── handlers/
// │       │       │   │           └── CreateCustomerHandler.java
// │       │       │   ├── query/                      # Read model (query) DTOs
// │       │       │   │   └── customer/
// │       │       │   │       ├── CustomerSummary.java
// │       │       │   │       └── handlers/
// │       │       │   │           └── GetCustomerSummaryHandler.java
// │       │       │   └── eventhandlers/              # Automation logic responding to events
// │       │       │       └── CustomerCreatedHandler.java
// │       │       ├── infrastructure/
// │       │       │   ├── persistence/
// │       │       │   │   ├── repositories/
// │       │       │   │   └── mappers/
// │       │       │   ├── readmodel/                  # Read model DB access or denormalization logic
// │       │       │   └── background/
// │       │       │       └── ScheduledTasks.java
// │       │       ├── interfaces/
// │       │       │   ├── web/
// │       │       │   │   └── CustomerController.java
// │       │       │   └── event/
// │       │       │       ├── listeners/
// │       │       │       └── publishers/
// │       │       └── ProjectApplication.java         # Main Spring Boot entry point
// │       └── resources/
// │           ├── application.yml
// │           ├── messages.properties
// │           └── db/
// │               └── migration/
// │                   └── V1__Init.sql
// ├── test/
// │   └── java/com/example/project/
// │       ├── unit/
// │       └── integration/
// ├── pom.xml
export const SPRINGBOOT_FOLDER_STRUCTURE = {
  root: {
    src: {
      main: {
        java: {
          com: {
            example: {
              root: {
                controller: {},
                model: {},
                service: {},
                repository: {},
                config: {},
                dto: {}
              }
            }
          }
        },
        resources: {
          'application.properties': {}
        }
      },
      test: {
        java: {
          com: {
            example: {
              root: {}
            }
          }
        }
      }
    },
    'pom.xml': {},
    'README.md': {},
    prompts: {
      'promptReadModel.txt': {},
      'promptCommand.txt': {},
      'promptEntity.txt': {},
      'promptAutomation.txt': {}
    }
  }
}

// AI Code Generation Context Menu
export const CODE_EDITOR_APPLY_PATCH = 'apply-patch'
export const CODE_EDITOR_GENERATE_AGAIN = 'generate-again'
export const CODE_EDITOR_EDIT_PROMPT = 'edit-prompt'
export const CODE_EDITOR_COPY_PROMPT = 'copy-prompt'

export const CODE_EDITOR_APPLY_PATCH_FILE = 'apply-patch-file'
export const CODE_EDITOR_APPLY_PATCH_FOLDER = 'apply-patch-folder'

export const CODE_EDITOR_OPEN_FILE = 'open-file'
export const CODE_EDITOR_SAVE_FILE = 'save-file'

export const CODE_EDITOR_RENAME_FILE = 'rename-file'
export const CODE_EDITOR_RENAME_FOLDER = 'rename-folder'

export const CODE_EDITOR_ADD_FILE = 'add-file'
export const CODE_EDITOR_ADD_FOLDER = 'add-folder'

export const CODE_EDITOR_UPLOAD_FILE = 'upload-file'
export const CODE_EDITOR_UPLOAD_FOLDER = 'upload-folder'

export const CODE_EDITOR_DELETE_FILE = 'delete-file'
export const CODE_EDITOR_DELETE_FOLDER = 'delete-folder'

export const CODE_EDITOR_DOWNLOAD_FILE = 'download-file'
export const CODE_EDITOR_DOWNLOAD_FOLDER = 'download-folder'
